import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Message from "../LoadingError/Error";
import ReactPaginate from "react-paginate";
import { Button, Heading } from "@chakra-ui/react";
import { ListSliders } from "../../Redux/Actions/SliderAction";
import Slider from "./Slider";
import Loading from "../LoadingError/Loading";

const MainSliders = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const sliderList = useSelector((state) => state.sliderList);
  const { loading, error, slider, totalPages, currentPage } = sliderList;

  const sliderDelete = useSelector((state) => state.sliderDelete);
  const { error: errorDelete, success: successDelete } = sliderDelete;

  useEffect(() => {
    dispatch(ListSliders(page));
  }, [dispatch, successDelete, page]);

  const handlePageClick = (event) => {
    setPage(event.selected + 1);
  };

  return (
    <>
      <section className="content-main">
        <div className="content-header">
          <Heading as="h2" size="lg" color="teal.600">
            Sliders
          </Heading>
          <div>
            <Button as={Link}
              to="/addslider" type="submit" colorScheme="teal" _hover={{
                backgroundColor: "teal.600",
                color: "white",
              }}>
              Create New
            </Button>
          </div>
        </div>

        <div className="card mb-4 shadow-sm">
          <header className="card-header bg-white">
            <div className="row gx-3 py-3">
              <div className="col-lg-4 col-md-6 me-auto">
                <input
                  type="search"
                  placeholder="Search..."
                  className="form-control p-2"
                />
              </div>
            </div>
          </header>

          <div className="card-body">
            {errorDelete && <Message variant="alert-danger">{errorDelete}</Message>}
            {loading ? (
              <Loading />
            ) : error ? (
              <Message variant="alert-danger">{error}</Message>
            ) : (
              <div className="row">
                {slider.map((slider) => (
                  <Slider slider={slider} key={slider.id} />
                ))}
              </div>
            )}

            <ReactPaginate
              previousLabel={"previous"}
              nextLabel={"next"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default MainSliders;
